export enum BookingFlowEnum {
  Symptoms = 'Symptoms',
  VisitType = 'VisitType',
  InPersonVisit = 'InPersonVisit',
  HomeCareService = 'HomeCareService',
  Appointments = 'Appointments',
}
